export const FormField = {
  comment: 'comment',
} as const;
